import iesoLogoWithName from '../assets/ieso_with_name.svg';
import iesoLogo from '../assets/ieso.svg';
import useAuth from '../hooks/useAuth';

const Header = () => {
  const { user } = useAuth();

  const handleLogout = () => {
    window.location.href = "/logout";
  };

  return (
    <header className="embed-container col-lg-12 col-md-12 col-sm-12 d-flex align-items-center"
        style={{height:'80px', minHeight:'80px', position:'relative'}}>
        <div className="header-left-bg"></div>
        <div className="header-content">
            <div className="d-flex align-items-center">
                <span className="mr-3" style={{height:'56px', display:'flex', alignItems:'center'}}>
                    <img src={iesoLogoWithName} alt="IESO Logo" className="ieso-logo-img" style={{width:'150px', display:'flex', alignItems:'center'}} />
                </span>
                <p className="title mb-0 d-flex align-items-center">
                    ADAP
                </p>
            </div>
            <div>
                {user ? (
                    <>
                        <span className="welcome-user-text mr-2" style={{color: '#003366'}}>Welcome, {user.name}</span>
                        <span style={{alignItems:'center', marginLeft:'-6px', marginRight:'6px', filter: 'drop-shadow(2px 2px 8px rgba(0, 0, 0, 0.6))'}}>
                            <img src={iesoLogo} alt="IESO Logo" style={{width:'33px', verticalAlign:'middle'}} />
                        </span>
                        <button onClick={handleLogout} className="btn btn-header-logout">
                            <i className="fa fa-power-off me-2"></i>
                            <span className="logout-text">Logout</span>
                        </button>
                    </>
                ) : null}
            </div>
        </div>
    </header>
  );
};

export default Header;
